import styled from 'styled-components';

export const Label = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const LabelWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;
